import { TrendingUp } from "lucide-react";
import { LucideProps } from "lucide-react";

interface TrendingUpIconProps extends LucideProps {
  className?: string;
}

export default function TrendingUpIcon({ className = "", size = 24, ...props }: TrendingUpIconProps) {
  return <TrendingUp className={className} size={size} {...props} />;
}
